import { thunkProgress } from 'redux-progress';

import type { Dispatch, GetState } from 'model/State';
import { SOURCE, PO_NUMBER_UPDATE, CART_FOR_ORDER } from './types';
import { source, cartByOrderNumber, purchaseOrderNumberUpdate } from '../../api';

export const fetchSource = (sourceParam: string) => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();

  const sourceData = source(sourceParam, state);
  dispatch(thunkProgress(SOURCE, sourceData));
};

export const postPurchaseOrderNumberUpdate =
  (orderId: string, purchaseOrderNumberParam: string) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const hash = state.location.query?.hash;

    const PONumberUpdate = purchaseOrderNumberUpdate(
      orderId,
      purchaseOrderNumberParam,
      state,
      hash,
    );
    dispatch(
      thunkProgress(PO_NUMBER_UPDATE, PONumberUpdate, { poNumber: purchaseOrderNumberParam }),
    );
  };

export const fetchCartByOrderNumber =
  (orderId: number, hash?: string) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const purchaseData = cartByOrderNumber(orderId, state, hash);
    dispatch(thunkProgress(CART_FOR_ORDER, purchaseData, { orderId }));
  };
